<script>
import { Bar } from 'vue-chartjs';

function gradeColor(score) {
  if (score === null || score === undefined) return '#bdbdbd';
  if (score < 1) return '#e53935';
  if (score < 2) return '#fb8c00';
  if (score <= 2.5) return '#f9a825';
  return '#43a047';
}

// Рисует значение балла над каждым столбцом (как в PDF-отчёте).
// Если столбец почти достаёт до верха — подпись уходит внутрь белым, чтобы не обрезалась.
const valueLabelPlugin = {
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.save();
    ctx.font = '600 11px Arial, sans-serif';
    ctx.textAlign = 'center';
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      if (meta.hidden) return;
      const { top } = chart.chartArea;
      meta.data.forEach((element, index) => {
        const value = dataset.data[index];
        if (value === null || value === undefined) return;
        const { x, y } = element.tooltipPosition();
        const text = Number(value)
          .toFixed(2);
        if (y - top < 16) {
          ctx.fillStyle = '#ffffff';
          ctx.textBaseline = 'top';
          ctx.fillText(text, x, y + 4);
        } else {
          ctx.fillStyle = '#424242';
          ctx.textBaseline = 'bottom';
          ctx.fillText(text, x, y - 4);
        }
      });
    });
    ctx.restore();
  },
};

export default {
  name: 'DiagnosticsCompetencyChart',
  extends: Bar,
  props: {
    competencyDetails: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    competencyDetails() {
      this.render();
    },
  },
  mounted() {
    this.addPlugin(valueLabelPlugin);
    this.render();
  },
  methods: {
    render() {
      const details = this.competencyDetails || [];
      const labels = details.map(c => {
        const n = c.name || '';
        return n.length > 24 ? `${n.slice(0, 24) }…` : n;
      });
      const fullNames = details.map(c => c.name || '');
      const data = details.map(c =>
        c.score !== null && c.score !== undefined ? parseFloat(Number(c.score)
          .toFixed(2)) : null,
      );
      const backgroundColor = details.map(c => gradeColor(c.score));

      this.renderChart(
        {
          labels,
          datasets: [{
            label: 'Балл',
            data,
            backgroundColor,
            hoverBackgroundColor: details.map(c => `${gradeColor(c.score) }cc`),
            borderWidth: 0,
          }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                max: 3,
                stepSize: 0.5,
                fontSize: 11,
                fontColor: '#9e9e9e',
              },
              gridLines: {
                color: '#f0f0f0',
                zeroLineColor: '#e0e0e0',
              },
            }],
            xAxes: [{
              ticks: {
                fontSize: 11,
                fontColor: '#424242',
                maxRotation: 35,
                minRotation: 0,
              },
              gridLines: { display: false },
            }],
          },
          tooltips: {
            backgroundColor: '#212121',
            cornerRadius: 6,
            callbacks: {
              title: (items) => fullNames[items[0].index] || labels[items[0].index],
              label: (item) =>
                item.yLabel !== null ? ` Балл: ${Number(item.yLabel)
                  .toFixed(2)}` : ' Нет оценки',
            },
          },
        },
      );
    },
  },
};
</script>
